import { Api } from '@/munio/api/base'

class Action extends Api<{ integration: number; action: string }> {
  constructor(integrationId: number, ulid: string) {
    super({
      integration: integrationId,
      action: ulid,
    })
  }

  get() {
    return this.$get(this.$route('api.web.integration.action'))
  }

  events(page: number = 1) {
    return this.$get(this.$route('api.web.integration.action.events'), { page })
  }

  retry() {
    return this.$post(this.$route('api.web.integration.action.retry'))
  }

  cancel() {
    return this.$post(this.$route('api.web.integration.action.cancel'))
  }
}

export default Action
